import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import ApiService from "api/ApiService";
import {
  getLocalStorageValue,
  removeLocalStorageValue,
} from "utils/localStorage";

export interface UserState {
  loggedIn: boolean;
  username: string;
  email: string;
  hasPrivilegedAccess: boolean;
}

const initialState: UserState = {
  loggedIn: getLocalStorageValue(ApiService.authTokenKey) !== null,
  username: "",
  email: "",
  hasPrivilegedAccess: false,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<UserState>) => {
      state.loggedIn = true;
      state.username = action.payload.username;
      state.email = action.payload.email;
      state.hasPrivilegedAccess = action.payload.hasPrivilegedAccess;
    },
    logout: (state) => {
      removeLocalStorageValue(ApiService.authTokenKey);
      state.loggedIn = false;
      state.username = "";
      state.email = "";
      state.hasPrivilegedAccess = false;
    },
  },
});

export const { setUser, logout } = userSlice.actions;

export default userSlice.reducer;
